export default "__VITE_ASSET__CJG_Eq97__"